import React from "react";

import CollectorStatus from "../Components/CollectorStatus/CollectorStatus";
import Header from "../Components/Header/Header";
import CollectorTable from "../Components/Tables/CollectorTable";



export default Collectors => {
    return (
        <>
            <Header />
            <div className="mt-14">
                <CollectorStatus />
            </div>
            <div className="mt-10">
                <CollectorTable />
            </div>
        </>
    )
} 